<template>
    <div class="jodit-popup__content shadow-md !p-0 !px-0.5">
        <div
            class="jodit-toolbar-editor-collection jodit-toolbar-editor-collection_mode_horizontal jodit-toolbar-editor-collection_size_middle"
        >
            <input tab-index="-1" disabled="true" style="width: 0; height: 0; position: absolute; visibility: hidden" />
            <div class="jodit-ui-group jodit-ui-group_line_true jodit-ui-group_size_middle">
                <div class="jodit-ui-group jodit-ui-group_size_middle">
                    <span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_bold jodit-ui-group__bold"
                        :class="[activeStates.bold ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="bold"
                        ref="bold"
                        aria-label="Bold"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'bold')"
                        >
                            <span class="jodit-toolbar-button__icon"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1792 1792"
                                    class="jodit-icon_bold jodit-icon"
                                >
                                    <path
                                        d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"
                                    ></path></svg></span
                            ><span class="jodit-toolbar-button__text"></span></button></span
                    ><span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_italic jodit-ui-group__italic"
                        :class="[activeStates.italic ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="italic"
                        ref="italic"
                        aria-label="Italic"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'italic')"
                        >
                            <span class="jodit-toolbar-button__icon"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1792 1792"
                                    class="jodit-icon_italic jodit-icon"
                                >
                                    <path
                                        d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"
                                    ></path></svg></span
                            ><span class="jodit-toolbar-button__text"></span></button></span
                    ><span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_strikethrough jodit-ui-group__strikethrough"
                        :class="[activeStates.strikethrough ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="strikethrough"
                        ref="strikethrough"
                        aria-label="Strike through"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'strikethrough')"
                        >
                            <span class="jodit-toolbar-button__icon"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1792 1792"
                                    class="jodit-icon_strikethrough jodit-icon"
                                >
                                    <path
                                        d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"
                                    ></path></svg></span
                            ><span class="jodit-toolbar-button__text"></span></button
                    ></span>
                    <div class="jodit-ui-separator"></div>
                    <span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_ul jodit-ui-group__ul"
                        :class="[activeStates.insertunorderedlist ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="ul"
                        ref="ul"
                        aria-label="Insert Unordered List"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'insertunorderedlist')"
                        >
                            <span class="jodit-toolbar-button__icon"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1792 1792"
                                    class="jodit-icon_ul jodit-icon"
                                >
                                    <path
                                        stroke-width="0"
                                        d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"
                                    ></path></svg></span
                            ><span class="jodit-toolbar-button__text"></span></button></span
                    ><span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_ol jodit-ui-group__ol"
                        :class="[activeStates.insertorderedlist ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="ol"
                        ref="ol"
                        aria-label="Insert Ordered List"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'insertorderedlist')"
                        >
                            <span class="jodit-toolbar-button__icon"
                                ><svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 1792 1792"
                                    class="jodit-icon_ol jodit-icon"
                                >
                                    <path
                                        stroke-width="0"
                                        d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"
                                    ></path></svg></span
                            ><span class="jodit-toolbar-button__text"></span></button
                    ></span>
                    <div class="jodit-ui-separator"></div>
                    <!-- Quotes -->
                    <span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_ol jodit-ui-group__ol"
                        :class="[activeStates.blockquote ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="ol"
                        ref="ol"
                        aria-label="Insert Ordered List"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'blockquote')"
                        >
                            <span class="jodit-toolbar-button__icon">
                                <svg
                                    data-v-895b2833=""
                                    class="svg-inline--fa fa-quotes jodit-icon_ol jodit-icon !h-5 !w-5"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fal"
                                    data-icon="quotes"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                >
                                    <path
                                        stroke-width="1"
                                        d="M0 88C0 39.4 39.4 0 88 0l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0C57.1 32 32 57.1 32 88l0 10.7C37 97 42.4 96 48 96l32 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-8 0-24L0 88zm32 56l0 24 0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM160 88c0-48.6 39.4-88 88-88l8 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-8 0c-30.9 0-56 25.1-56 56l0 10.7c5-1.8 10.4-2.7 16-2.7l32 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-8 0-24 0-56zm32 80l0 8c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 24zM576 424c0 48.6-39.4 88-88 88l-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0c30.9 0 56-25.1 56-56l0-10.7c-5 1.8-10.4 2.7-16 2.7l-32 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8 0 24 0 56zm-32-56l0-24 0-8c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM416 424c0 48.6-39.4 88-88 88l-8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l8 0c30.9 0 56-25.1 56-56l0-10.7c-5 1.8-10.4 2.7-16 2.7l-32 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 8 0 24 0 56zm-32-80l0-8c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-24z"
                                    ></path>
                                </svg> </span
                            ><span class="jodit-toolbar-button__text"></span></button
                    ></span>
                    <div class="jodit-ui-separator"></div>

                    <!-- Spell Check -->
                    <span
                        class="jodit-toolbar-button jodit-toolbar-button_size_middle jodit-toolbar-button_variant_initial jodit-toolbar-button_ol jodit-ui-group__ol"
                        :class="[activeStates.toggleSpellcheck ? 'bg-gray-100' : '']"
                        role="listitem"
                        data-ref="ol"
                        ref="ol"
                        aria-label="Insert Ordered List"
                        ><button
                            class="jodit-toolbar-button__button"
                            type="button"
                            role="button"
                            aria-pressed="false"
                            tabindex="-1"
                            @click="emits('handleStyle', 'toggleSpellcheck')"
                        >
                            <span class="jodit-toolbar-button__icon">
                                <svg
                                    data-v-895b2833=""
                                    class="svg-inline--fa fa-spell-check fa-2x jodit-icon !h-5 !w-5"
                                    aria-hidden="true"
                                    focusable="false"
                                    data-prefix="fal"
                                    data-icon="spell-check"
                                    role="img"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 576 512"
                                >
                                    <path
                                        class=""
                                        d="M126.7 9.7C124.2 3.8 118.4 0 112 0s-12.2 3.8-14.7 9.7l-96 224c-3.5 8.1 .3 17.5 8.4 21s17.5-.3 21-8.4L54 192l116 0 23.3 54.3c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-96-224zM156.3 160l-88.6 0L112 56.6 156.3 160zM256 16l0 112 0 112c0 8.8 7.2 16 16 16l104 0c39.8 0 72-32.2 72-72c0-31.1-19.7-57.6-47.3-67.6C410.3 104.1 416 88.7 416 72c0-39.8-32.2-72-72-72L272 0c-8.8 0-16 7.2-16 16zm88 96l-56 0 0-80 56 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-56 32l56 0 32 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-88 0 0-80zM571.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L352 473.4 251.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l208-208z"
                                    ></path>
                                </svg> </span
                            ><span class="jodit-toolbar-button__text"></span></button
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
const emits = defineEmits(["handleStyle"]);
const props = defineProps({
    activeStates: {
        type: Object,
        default: {},
    },
});
</script>
